import styled from 'styled-components'
import { SPACING, BORDER_RADIUS, COLORS, TYPOGRAPHY, FONT_WEIGHT } from '../../../styles/theme'

export const InsightsContainer = styled.div`
  padding: ${SPACING.xl} ${SPACING.xl} ${SPACING.xxxl};
  max-width: 960px;
  margin: 0 auto;

  @media print {
    padding: 0;
    max-width: 100%;
  }
`

export const InsightsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: ${SPACING.lg};
  margin-bottom: ${SPACING.lg};
`

export const HeaderLeft = styled.div`
  flex: 1;
  min-width: 0;
`

export const HeaderActions = styled.div`
  display: flex;
  gap: ${SPACING.sm};
  flex-shrink: 0;

  @media print {
    display: none;
  }
`

export const InsightsPageHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md};
  margin-bottom: ${SPACING.xl};
`

export const InsightsTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.lg};
`

export const InsightsActionsRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.sm};
  padding-left: calc(32px + ${SPACING.lg});

  @media print {
    display: none;
  }
`

export const MetaRow = styled.div`
  display: flex;
  gap: ${SPACING.sm};
  flex-wrap: wrap;
  margin-bottom: ${SPACING.xl};
`

export const MetaBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  background: ${COLORS.primaryBg};
  border: 1px solid ${COLORS.primary}33;
  border-radius: ${BORDER_RADIUS.full};
  padding: 4px ${SPACING.md};
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.medium};
  color: var(--color-text-primary);
`

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid var(--color-border);
  margin: 0 0 ${SPACING.xl} 0;
`

export const QuestionsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xl};

  @media print {
    gap: ${SPACING.lg};
  }
`

export const EmptyState = styled.div`
  text-align: center;
  padding: ${SPACING.xxxl} ${SPACING.xl};
  color: var(--color-text-secondary);
  border: 1px dashed var(--color-border);
  border-radius: ${BORDER_RADIUS.xl};
`

export const EmptyStateTitle = styled.div`
  font-size: ${TYPOGRAPHY.body.fontSize};
  font-weight: ${FONT_WEIGHT.semibold};
  color: var(--color-text-primary);
  margin-bottom: ${SPACING.sm};
`

export const EmptyStateText = styled.div`
  font-size: ${TYPOGRAPHY.caption.fontSize};
`

export const ClosedBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--color-bg-secondary);
  border: 1px solid var(--color-border);
  border-radius: ${BORDER_RADIUS.full};
  padding: 4px ${SPACING.md};
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.medium};
  color: var(--color-text-secondary);
`

export const SummarySection = styled.div`
  margin-bottom: ${SPACING.xl};
`

export const MismatchBanner = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${SPACING.md};
  background: #fff7ed;
  border: 1px solid #fdba74;
  border-radius: ${BORDER_RADIUS.lg};
  padding: ${SPACING.md} ${SPACING.lg};
  margin-bottom: ${SPACING.xl};
  font-size: ${TYPOGRAPHY.caption.fontSize};
  color: #92400e;

  [data-theme='dark'] & {
    background: rgba(251, 191, 36, 0.08);
    border-color: rgba(251, 191, 36, 0.3);
    color: #fbbf24;
  }
`
